import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { ELEVATED_ROLES } from '@/lib/constants/auth.constants';
import { HttpStatus } from '@/lib/constants/http.status';
import { AppServerError } from '@/lib/errors';
import { standardMiddlewares } from '@/middlewares/standardMiddlewares';
import { assertSelfOrRole } from '@/middlewares/userAuthMiddleware';

import { User } from '../validators/schemas';

type GetAgentsResponse = {
  data: User[] | null;
  success: boolean;
  error: string | null;
};

export const getAgents = createServerFn({ method: 'POST' })
  .middleware([standardMiddlewares])
  .validator(
    z.object({
      sourcedId: z.string(),
    })
  )
  .handler(async ({ context: { oneRosterApiTyped, cognitoUser }, data }) => {
    await assertSelfOrRole(cognitoUser, oneRosterApiTyped, data.sourcedId, ELEVATED_ROLES);
    const response = await oneRosterApiTyped.GET(
      `/ims/oneroster/rostering/v1p2/users/{userId}/agents`,
      {
        params: {
          path: {
            userId: data.sourcedId,
          },
        },
      }
    );

    if (!response) {
      const error = new AppServerError(
        'Error::getAgents',
        HttpStatus.InternalServerError,
        {
          sourcedId: data.sourcedId,
        },
        true
      );
      error.cause = response;
      throw error;
    }

    return {
      data: response.data?.agents,
      success: true,
      error: null,
    } as GetAgentsResponse;
  });
